package org.hs_soft.runmynesto.domain.model.home.template.tabs.tab_general.select_days

import androidx.compose.runtime.Composable
import org.hs_soft.runmynesto.domain.util.helper.LanguageManager
import org.hs_soft.runmynesto.domain.util.helper.Strings

enum class DayWeekEnum(
    val value: Int
) {
    ALL_DAYS(127),
    MONDAY(1),
    TUESDAY(2),
    WEDNESDAY(4),
    THURSDAY(8),
    FRIDAY(16),
    SATURDAY(32),
    SUNDAY(64);

    @Composable
    fun getTitle(): String {
        val strings = Strings.current()
        return when (this) {
            ALL_DAYS -> strings.allDays
            MONDAY -> strings.mondayFull
            TUESDAY -> strings.tuesdayFull
            WEDNESDAY -> strings.wednesdayFull
            THURSDAY -> strings.thursdayFull
            FRIDAY -> strings.fridayFull
            SATURDAY -> strings.saturdayFull
            SUNDAY -> strings.sundayFull
        }
    }

    val title: String
        get() = LanguageManager.getCurrentStrings().let { strings ->
            when (this) {
                ALL_DAYS -> strings.allDays
                MONDAY -> strings.mondayFull
                TUESDAY -> strings.tuesdayFull
                WEDNESDAY -> strings.wednesdayFull
                THURSDAY -> strings.thursdayFull
                FRIDAY -> strings.fridayFull
                SATURDAY -> strings.saturdayFull
                SUNDAY -> strings.sundayFull
            }
        }
}